'use strict';

var _ = require('lodash');

/**
 * Brush Extent Service
 * @constructor
 */
var BrushRangesService = function BrushRangesService() {
  function getRangeLabels(chartData, values) {
    if (values.length === 2) {
      return _.map(chartData.slice(values[0], values[1]), 'label');
    }
  }

  /**
   * Get number of selected ranges
   * @param {Array} ranges
   * @returns {Integer}
   */
  function getNumberOfRanges(ranges) {
    return _.reduce(ranges, function (size, range) {
      size += range[1] - range[0];
      return size;
    }, 0);
  }

  /**
   * Creates an array of ranges.
   * @param {Array} indexes
   * @returns {Array}
   */
  function combineToRanges(indexes) {
    var ranges = [];
    if (indexes.length > 0) {
      var start = indexes[0];
      var end = indexes[0] - 1;
      for (var i = 0; i < indexes.length; i++) {
        var currentIndex = indexes[i];
        if (currentIndex !== end + 1) {
          ranges.push([start, end + 1]);
          start = currentIndex;
        }
        end = currentIndex;
      }
      ranges.push([start, end + 1]);
    }
    return ranges;
  }

  /**
   * Gets data ranges
   * @param {Array} chartData
   * @param {Array} brushRanges
   * @returns {Array}
   */
  function getDataRange(chartData, brushRanges) {
    var rangesSize = getNumberOfRanges(brushRanges);
    return Array.isArray(chartData) && rangesSize > 0 ? _.chain(brushRanges).map(function (range) {
      range = range.map(function (entry) {
        return Math.ceil(entry);
      });
      return getRangeLabels(chartData, range);
    }).flatten().value() : [];
  }
  return {
    getDataRange: getDataRange,
    combineToRanges: combineToRanges,
    getNumberOfRanges: getNumberOfRanges
  };
};
BrushRangesService.$inject = [];
module.exports = BrushRangesService;